# About fab-friday-template

This is a Fab-Friday project of The Things Industries.
